module.exports = __webpack_public_path__ + "static/media/Icon material-device-hub1.1c665888.svg";